import React from 'react'
import { Navigate } from 'react-router-dom'
import { Loader } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'

interface SchoolMemberRouteProps {
  children: React.ReactNode
}

/**
 * Guard de `/app/escola`. Exige **vínculo** com uma escola, não coordenação.
 *
 * Substitui `SchoolAdminProtectedRoute`, que exigia `isSchoolAdmin` e por isso
 * trancava a área para o professor membro — que tem abas próprias (Conteúdo e
 * Padrão em leitura). Quem é coordenação é decidido dentro da área, por
 * `get_my_school().is_admin`, e cada aba de gestão confere de novo.
 */
const SchoolMemberRoute: React.FC<SchoolMemberRouteProps> = ({ children }) => {
  const { user, profile, loading: authLoading } = useAuth()

  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-cream-100 dark:bg-ink-900">
        <Loader className="w-8 h-8 text-terra-500 animate-spin" />
        <p className="ml-2 text-ink-700 dark:text-cream-300">Verificando permissões...</p>
      </div>
    )
  }

  if (!user || !profile?.school_id) {
    return <Navigate to="/app" replace />
  }

  return <>{children}</>
}

export default SchoolMemberRoute
